if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector(
          '[type="submit"]'
        );

        this.submitButtonText =
          this.submitButton.querySelector('span');

        this.loadingSpinner = this.querySelector(
          '.loading__spinner'
        );

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add('loading');

        this.loadingSpinner?.classList.remove(
          'hidden'
        );

        const quickAddModal =
          this.closest('quick-add-modal');

        const isCartDrawer =
          this.cart?.matches('cart-drawer');

        if (this.cart) {
          this.cart.setActiveElement?.(
            document.activeElement
          );

          if (isCartDrawer && !quickAddModal) {
            this.cart.open?.(
              document.activeElement
            );

            this.cart.setLoading?.(
              true,
              'Adding to your cart…'
            );
          }
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId:
                  formData.get('id'),
                errors:
                  response.errors ||
                  response.description,
                message: response.message,
              });

              this.handleErrorMessage(
                response.description ||
                  response.message
              );

              this.cart?.setLoading?.(false);

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  'aria-disabled',
                  'true'
                );

                this.submitButtonText?.classList.add(
                  'hidden'
                );

                soldOutMessage.classList.remove(
                  'hidden'
                );
              }

              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId:
                formData.get('id'),
              cartData: response,
            });

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () =>
                  window.setTimeout(() =>
                    this.cart.renderContents(
                      response
                    )
                  ),
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);

            this.error = true;

            this.cart?.setLoading?.(false);

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            this.loadingSpinner?.classList.add(
              'hidden'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              ) &&
              !this.error
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );

              this.cart?.setLoading?.(false);
            }
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}